import React, { useEffect } from "react";
import { useAuthStore } from "../../stores/auth-store";
import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import { CompanyAdminDashboard } from "../../components/CompanyAdmin/CompanyAdminDashboard";
import CompanyAdminProhibited from "../../components/CompanyAdmin/CompanyAdminProhibited";

export const CompanyAdminPage: React.FC = () => {
  return (
    <CompanyAdminLayout>
      <div className="p-5">
        <CompanyAdminDashboard />
      </div>
    </CompanyAdminLayout>
  );
};
